<template>
	<div class="w-100" v-if="!hasError">
		<div class="d-flex align-items-center gap-10px w-100">
			<img src="../../../assets/newdesign/landing/progressHub.svg" alt="" />
			<div class="fam-mont fw-M fs-16 color-6A6A6A line-height-normal">
				PROGRESS HUB
			</div>
		</div>
		<!-- card sections -->

		<MainCard class="w-100" @load-error="onLoadError" />
	</div>
</template>
<script>
import MainCard from "./MainCard.vue";
export default {
	name: "ProgressHub",
	components: {
		MainCard,
	},
	data() {
		return {
			hasError: false,
		};
	},
	methods: {
		onLoadError() {
			this.hasError = true;
		},
	},
};
</script>
<!-- <script>
import HorizontalScroll from "../../fixedcomponents/HorizontalScroll.vue";
// import SubJobCard from "./SubJobCard.vue";
// import SubAssessCard from "./SubAssessCard.vue";
// import SubCourseCard from "./SubCourseCard.vue";
// import MainCourseCard from "./MainCourseCard.vue";
// import MainAssessCard from "./MainAssessCard.vue";
// import MainJobCard from "./MainJobCard.vue";
import TestDetailsAP from "@/views/AssessmentProgress/TestDetailsAP.vue";
import { getProgressHubData, getAssessmentDetail } from "@/utils/apiFunctions";
import { config } from "@/config";

const TAB_META = { courses: "Courses", assessments: "Tests", jobs: "Jobs" };

export default {
	name: "ProgressHub",
	components: {
		HorizontalScroll,
		SubJobCard,
		SubAssessCard,
		SubCourseCard,
		MainCourseCard,
		MainAssessCard,
		MainJobCard,
		TestDetailsAP,
	},
	data() {
		return {
			activeTab: "all", // 'all', 'courses', 'assessments', 'jobs'
			tabIndex: 0, // numeric index for b-tabs v-model
			priority: "course", // 'course', 'assessment', 'job'
			isLaptop: window.innerWidth >= 1024,
			progressHubSections: {
				jobs: [],
				assessments: [],
				courses: [],
			},
			progressHubVisibleSections: [],
			isLoading: true,

			// Test details modal state
			showTestDetails: false,
			selectedAssessment: null,
			isPublic: false,

			// Reactive scroll el refs for HorizontalScroll
			cardContainerEl: null,
			// Saved scroll positions per tab for the laptop card-container
			tabScrollPositions: { courses: 0, assessments: 0, jobs: 0 },
			mobCourseScrollEl: null,
			mobAssessScrollEl: null,
			mobJobScrollEl: null,

			// Scrollability flags — true only when container overflows horizontally
			scrollable: {
				cardContainer: false,
				mobCourse: false,
				mobAssess: false,
				mobJob: false,
			},

			// Draggable Mobile State
			isMobile: window.innerWidth <= 1028,
			translateY: 0,
			isDragging: false,
			startY: 0,
			startTranslateY: 0,
			peekVisible: 130, // Account for Bottom Nav (~73px) + Hub Header title only (~48px)
			topMargin: 64, // Mobile Header height
		};
	},
	watch: {
		// When b-tabs changes its active index, update activeTab string
		tabIndex(newIndex) {
			this.activeTab = this.visibleTabs[newIndex]?.key || "all";
		},
		// Allow programmatic changes to activeTab to also update the b-tabs nav
		activeTab(newTab, oldTab) {
			// Save scroll position of the outgoing laptop tab
			const el = this.$refs["card-container"];
			if (el && oldTab && oldTab !== "all") {
				this.tabScrollPositions[oldTab] = el.scrollLeft;
			}

			// On mobile, snapshot how many px of the hub are currently visible
			// above the bottom edge before the tab content changes container height.
			// We preserve that visible amount after the reflow.
			let visiblePx = null;
			if (this.isMobile) {
				const container = this.$refs.hubContainer;
				if (container) {
					visiblePx = container.offsetHeight - this.translateY;
				}
			}

			// Freeze the sheet in place while Vue re-renders the new tab content
			// so the old translateY on the resized container is never animated.
			if (this.isMobile && visiblePx !== null) {
				this.isDragging = true;
			}

			this.$nextTick(() => {
				this.cardContainerEl = this.$refs["card-container"] || null;
				this.mobCourseScrollEl = this.$refs["mob-course-scroll"]?.$el || null;
				this.mobAssessScrollEl = this.$refs["mob-assess-scroll"]?.$el || null;
				this.mobJobScrollEl = this.$refs["mob-job-scroll"]?.$el || null;
				this.updateScrollableFlags();
				// Restore scroll position for the incoming laptop tab
				if (this.cardContainerEl && newTab !== "all") {
					this.cardContainerEl.scrollLeft =
						this.tabScrollPositions[newTab] || 0;
				}
				// Re-anchor the sheet so the same amount of hub stays visible after
				// the content reflow changes the container height. Transition is still
				// off (isDragging = true) so this lands instantly with no animation.
				if (this.isMobile && visiblePx !== null) {
					const container = this.$refs.hubContainer;
					if (container) {
						const newPeekLimit = container.offsetHeight - this.peekVisible;
						const newTranslateY = container.offsetHeight - visiblePx;
						this.translateY = Math.min(
							Math.max(newTranslateY, 0),
							newPeekLimit
						);
					}
					// Corrected position is now painted. Re-enable transitions so
					// future drags animate normally.
					requestAnimationFrame(() => {
						this.isDragging = false;
					});
				}
			});
			const idx = this.visibleTabs.findIndex((t) => t.key === newTab);
			if (idx !== -1 && idx !== this.tabIndex) {
				this.tabIndex = idx;
			}
		},
	},
	computed: {
		hasAnyData() {
			return this.progressHubVisibleSections.length > 0;
		},
		visibleTabs() {
			const tabs = [{ key: "all", label: "All" }];
			for (const section of this.progressHubVisibleSections) {
				if (TAB_META[section]) {
					tabs.push({ key: section, label: TAB_META[section] });
				}
			}
			return tabs;
		},
		showCourses() {
			const canRenderCourseMain =
				this.activeTab === "courses" &&
				this.progressHubVisibleSections.includes("courses");
			const canRenderCoursePriority =
				this.priority === "courses" && this.activeTab === "all";
			return canRenderCoursePriority || canRenderCourseMain;
		},

		showAssessments() {
			const canRenderAssessmentMain =
				this.activeTab === "assessments" &&
				this.progressHubVisibleSections.includes("assessments");
			const canRenderAssessmentPriority =
				this.priority === "assessments" && this.activeTab === "all";
			return canRenderAssessmentPriority || canRenderAssessmentMain;
		},

		showJobs() {
			const canRenderJobMain =
				this.activeTab === "jobs" &&
				this.progressHubVisibleSections.includes("jobs");
			const canRenderJobPriority =
				this.priority === "jobs" && this.activeTab === "all";
			return canRenderJobPriority || canRenderJobMain;
		},
		courseMainData() {
			return this.progressHubSections?.courses;
		},
		assessmentMainData() {
			return this.progressHubSections?.assessments;
		},
		jobMainData() {
			return this.progressHubSections?.jobs;
		},
		jobSubItems() {
			return this.progressHubSections.jobs.slice(0, 2);
		},
		assessmentSubItems() {
			return this.progressHubSections.assessments.slice(0, 2);
		},
		courseSubItems() {
			return this.progressHubSections.courses.slice(0, 2);
		},
		showJobsWidget() {
			return (
				this.activeTab === "all" &&
				this.priority != "jobs" &&
				this.progressHubVisibleSections.includes("jobs")
			);
		},
		showAssessmentsWidget() {
			return (
				this.activeTab === "all" &&
				this.priority != "assessments" &&
				this.progressHubVisibleSections.includes("assessments")
			);
		},
		showCoursesWidget() {
			return (
				this.activeTab === "all" &&
				this.priority != "courses" &&
				this.progressHubVisibleSections.includes("courses")
			);
		},
		// Returns the data array for the currently active tab so the laptop
		// HorizontalScroll recalculates scrollMax whenever the tab changes.
		activeTabData() {
			if (this.activeTab === "courses") return this.courseMainData;
			if (this.activeTab === "assessments") return this.assessmentMainData;
			if (this.activeTab === "jobs") return this.jobMainData;
			return [];
		},
	},
	methods: {
		syncProgressHubState(payload = {}) {
			this.priority = payload.prioritySection || "courses";
			this.progressHubSections = payload.sections || {
				jobs: [],
				assessments: [],
				courses: [],
			};
			this.progressHubVisibleSections = payload.visibleSections || [];
			this.$emit("hub-status", this.hasAnyData || this.isLoading);
		},
		calculatePeekVisible() {
			if (!this.isMobile) return;
			const safeArea =
				parseFloat(
					window
						.getComputedStyle(document.documentElement)
						.getPropertyValue("--safe-area-inset-bottom")
				) || 0;

			const bottomNav = document.querySelector(".mobile-bottom-nav");
			if (bottomNav) {
				const navHeight = bottomNav.offsetHeight;

				// Dynamically calculate the header height (top of container to top of tabs)
				let headerHeight = 48;
				const container = this.$refs.hubContainer;
				if (container) {
					const tabsEl = container.querySelector(".ph-tabs");
					if (tabsEl) {
						const rectContainer = container.getBoundingClientRect();
						const rectTabs = tabsEl.getBoundingClientRect();
						if (rectTabs.top > rectContainer.top) {
							// Subtract 4px buffer to ensure tabs are fully hidden behind the bottom nav
							headerHeight = Math.max(35, rectTabs.top - rectContainer.top - 4);
						}
					}
				}

				this.peekVisible = navHeight + headerHeight;
			} else {
				this.peekVisible = 120 + safeArea;
			}
		},
		updateDimensions() {
			this.isMobile = window.innerWidth <= 1028;
			this.calculatePeekVisible();
			this.$nextTick(() => {
				this.updateScrollableFlags();
				this.calculatePeekVisible();
			});
			if (!this.isMobile) {
				this.translateY = 0;
			} else if (!this.isDragging) {
				const container = this.$refs.hubContainer;
				if (container) {
					const h = container.offsetHeight;
					const peekThreshold = h - this.peekVisible;
					// Snap only if very close to ends, else keep current
					if (this.translateY < 50) {
						this.translateY = 0;
					} else if (this.translateY > peekThreshold - 50) {
						this.translateY = peekThreshold;
					}
				}
			}
		},
		onDragStart(e) {
			if (!this.isMobile) return;
			this.isDragging = true;
			this.startY = e.touches[0].clientY;
			this.startTranslateY = this.translateY;
		},
		onDragMove(e) {
			if (!this.isDragging) return;
			const currentY = e.touches[0].clientY;
			const diff = currentY - this.startY;
			let targetY = this.startTranslateY + diff;

			const h = this.$refs.hubContainer.offsetHeight;
			const peekLimit = h - this.peekVisible;

			// Constraints for bottom-anchored sheet
			// targetY = 0 is fully open. targetY = peekLimit is minimized.
			if (targetY < 0) targetY = 0;
			if (targetY > peekLimit) targetY = peekLimit;

			this.translateY = targetY;
		},
		onDragEnd() {
			if (!this.isDragging) return;
			this.isDragging = false;

			const h = this.$refs.hubContainer.offsetHeight;
			const peekLimit = h - this.peekVisible;
			const halfway = peekLimit / 2;

			const isMovingDown = this.translateY > this.startTranslateY;
			const isMovingUp = this.translateY < this.startTranslateY;

			if (isMovingDown) {
				// Case 1: From Full -> Snap to Half
				if (this.startTranslateY < 40) {
					this.translateY = halfway;
				}
				// Case 2: From Half/Middle -> Snap to Peek
				else {
					this.translateY = peekLimit;
				}
			} else if (isMovingUp) {
				// Snap to Full (Top) if reached past half screen
				if (this.translateY < halfway) {
					this.translateY = 0;
				}
				// Otherwise stay exactly where left
			}
		},
		async openAssessmentDetails(item) {
			const testID = item?.id || item?.testID;
			if (!testID) return;
			try {
				const params = {
					testID,
					...(item?.groupID && { groupID: item.groupID }),
				};
				const res = await getAssessmentDetail(params);
				if (res.status === 200) {
					this.selectedAssessment = res.data.data;
					if (this.isMobile) {
						this.$store.commit(
							"candidateVUEX/addSelectAssess",
							this.selectedAssessment
						);
						this.$router
							.push({
								name: "mobAssessment",
								query: { public: false, from: "home" },
							})
							.catch(() => {});
					} else {
						this.showTestDetails = true;
					}
				}
			} catch (e) {
				this.$router.push(`/assessment/${testID}/details`).catch(() => {});
			}
		},
		handleCtaAction(item = {}) {
			if (item?.type === "assessment") {
				this.openAssessmentDetails(item);
				return;
			} else if (item?.type === "course") {
				this.goToTraining(item.ctaLink);
			} else {
				const ctaLink = item?.ctaLink;
				if (!ctaLink) return;
				if (/^https?:\/\//i.test(ctaLink)) {
					window.open(ctaLink, "_self");
					return;
				}
				this.$router.push(ctaLink).catch(() => {});
			}
		},
		navigateBasedOnPriority() {
			if (this.priority === "courses") {
				this.goToTraining("/dashboard");
				return;
			}
			if (this.priority === "assessments") {
				this.$router.push("/assessment/progress").catch(() => {});
				return;
			}
			if (this.priority === "jobs") {
				this.$router.push("/job/progress").catch(() => {});
				return;
			}
		},
		goToTraining(redirect) {
			window.location.href = `${config.trainingBase}${redirect}`;
		},
		navigateBasedOnActiveTab() {
			if (this.activeTab === "courses") {
				this.goToTraining("/dashboard");
				return;
			}
			if (this.activeTab === "assessments") {
				this.$router.push("/assessment/progress").catch(() => {});
				return;
			}
			if (this.activeTab === "jobs") {
				this.$router.push("/job/progress").catch(() => {});
				return;
			}
		},
		isContainerScrollable(el) {
			if (!el) return false;
			return el.scrollWidth > el.clientWidth;
		},
		updateScrollableFlags() {
			this.scrollable = {
				cardContainer: this.isContainerScrollable(this.cardContainerEl),
				mobCourse: this.isContainerScrollable(this.mobCourseScrollEl),
				mobAssess: this.isContainerScrollable(this.mobAssessScrollEl),
				mobJob: this.isContainerScrollable(this.mobJobScrollEl),
			};
		},
		async initializeProgressHub() {
			this.isLoading = true;
			this.$emit("hub-status", true);
			try {
				const res = await getProgressHubData();
				const payload = res?.data?.data || {};
				this.syncProgressHubState(payload);
			} catch (error) {
				this.syncProgressHubState({});
			} finally {
				this.isLoading = false;
				this.$emit("hub-status", this.hasAnyData || this.isLoading);
			}
		},
	},
	created() {
		this.initializeProgressHub();
	},
	mounted() {
		this.calculatePeekVisible();
		this.updateDimensions();
		window.addEventListener("resize", this.updateDimensions);
		this.$nextTick(() => {
			this.cardContainerEl = this.$refs["card-container"] || null;
			this.updateScrollableFlags();
		});
		if (this.isMobile) {
			this.$nextTick(() => {
				this.calculatePeekVisible();
				const h = this.$refs.hubContainer.offsetHeight;
				this.translateY = h - this.peekVisible;
			});
		}
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.updateDimensions);
	},
};
</script> -->

<style scoped></style>
